import React from 'react';

const beneficios = [
  {
    icono: 'fa-truck',
    titulo: 'Entrega inmediata',
    texto: 'Amplio stock en bodega para que tu proyecto no espere.',
  },
  {
    icono: 'fa-leaf',
    titulo: 'Sustentables y sin mantenimiento',
    texto: 'Recubrimientos para pisos y muros que no requieren mantenimiento.',
  },
  {
    icono: 'fa-comments',
    titulo: 'Cotización y asesoría',
    texto: 'Escríbenos y recibe información personalizada del producto que buscas.',
  },
  {
    icono: 'fa-award',
    titulo: 'Garantía de calidad',
    texto: 'Distribuimos productos de alta calidad para pisos y muros.',
  },
];

const BeneficiosHome = () => {
  return (
    <section className="dt-benef dt-section">
      <div className="container">
        <div className="dt-head wow fadeIn" data-wow-delay="200ms">
          <div>
            <span className="dt-eyebrow">Por qué Decototal</span>
            <h2 className="h1 mb-0">Lo que encuentras al cotizar con nosotros</h2>
          </div>
          <a className="dt-link" href="/contacto-decototal">
            Cotiza ahora <i className="fas fa-arrow-right" aria-hidden="true"></i>
          </a>
        </div>

        <div className="dt-benef__grid">
          {beneficios.map((b, i) => (
            <div key={b.titulo} className="dt-benef__item wow fadeInUp" data-wow-delay={`${i * 100}ms`}>
              <div className="dt-benef__icon"><i className={`fas ${b.icono}`} aria-hidden="true"></i></div>
              <h3>{b.titulo}</h3>
              <p>{b.texto}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeneficiosHome;